export const CURRENT_USER = 'CURRENT_USER';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const WRONG_LOGIN = 'WRONG_LOGIN';
export const AUTO_LOGIN = 'AUTO_LOGIN';
export const VIEW_SHOW = 'VIEW_SHOW';
export const WATCHLIST = 'WATCHLIST';
export const GET_SHOW_PROGRESS = 'GET_SHOW_PROGRESS'
export const SIGNUP_ERRORS = 'SIGNUP_ERRORS'
